import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar, Clock, MapPin } from 'lucide-react';
export function Programs() {
  const [activeTab, setActiveTab] = useState<'monthly' | 'annual'>('monthly');
  const monthlyPrograms = [{
    title: 'NIWALE (Night Watchers Legislation)',
    schedule: '1st–5th every month',
    time: '9:00 PM daily',
    type: 'Prayer Meeting'
  }, {
    title: 'SPA (Supernatural & Prophetic Activations)',
    schedule: '11th every month',
    time: '9:00 PM',
    type: 'Activation'
  }, {
    title: 'NWC (New Wine Conference)',
    schedule: '15th–16th every month',
    time: '8:00 PM daily',
    type: 'Conference'
  }];
  const annualPrograms = [{
    title: 'Market Outreach',
    date: 'January',
    location: 'Local Markets'
  }, {
    title: 'Hospital Outreach',
    date: 'March',
    location: 'Hospitals'
  }, {
    title: 'Orphanage Outreach',
    date: 'May & December',
    location: 'Orphanages'
  }, {
    title: 'MYPR (Mid-Year Prayer Retreat)',
    date: 'June',
    location: 'Retreat Center'
  }, {
    title: 'Correctional Center Outreach (CCO)',
    date: 'August',
    location: 'Correctional Centers'
  }, {
    title: 'Village Outreach',
    date: 'October',
    location: 'Villages'
  }, {
    title: '10 Nights of Lambano',
    date: 'December',
    location: 'Online/In-person'
  }, {
    title: 'EOYPR (End-of-Year Prayer Retreat)',
    date: 'December',
    location: 'Retreat Camp'
  }];
  return <section id="programs" className="py-32 bg-ivory text-midnight" data-id="element-303" data-mp="1258kyiqh2wrb">
      <div className="max-w-7xl mx-auto px-6" data-id="element-304" data-mp="y0sfgikrtrcm">
        <div className="flex flex-col items-center text-center mb-16" data-id="element-305" data-mp="3mtehkzlylxfl">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/20 text-midnight rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-306" data-mp="3mupkkx7kz15n">
            2026 Calendar
          </div>
          <h3 className="text-5xl md:text-7xl font-display font-bold tracking-tighter mb-12" data-id="element-307" data-mp="3k9q6deksu327">
            Our{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-308" data-mp="3p5ypt4614if6">
              Programs
            </span>
          </h3>

          <div className="relative flex p-1.5 bg-midnight/5 rounded-full" data-id="element-309" data-mp="3f9lrtu3gbiem">
            <button onClick={() => setActiveTab('monthly')} className={`relative z-10 px-8 py-3 rounded-full text-sm font-bold tracking-wide transition-colors ${activeTab === 'monthly' ? 'text-ivory' : 'text-midnight hover:text-midnight/70'}`} data-id="element-310" data-mp="3fboqt3ml0lvh">
              Recurring Monthly
            </button>
            <button onClick={() => setActiveTab('annual')} className={`relative z-10 px-8 py-3 rounded-full text-sm font-bold tracking-wide transition-colors ${activeTab === 'annual' ? 'text-ivory' : 'text-midnight hover:text-midnight/70'}`} data-id="element-311" data-mp="2wiku19e2hswn">
              Annual Outreaches
            </button>

            {/* Animated Pill Indicator */}
            <div className="absolute inset-1.5 pointer-events-none flex" data-id="element-312" data-mp="1yy2tybwnzhw1">
              <motion.div className="h-full bg-midnight rounded-full" initial={false} animate={{
              width: '50%',
              x: activeTab === 'monthly' ? '0%' : '100%'
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-313" data-mp="1z05sjkbvujcd" />
            </div>
          </div>
        </div>

        <div className="min-h-[400px]" data-id="element-314" data-mp="2vnk5v8m8q066">
          <AnimatePresence mode="wait" data-id="element-315" data-mp="2rmgouisghy3d">
            {activeTab === 'monthly' ? <motion.div key="monthly" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} className="grid md:grid-cols-3 gap-6" data-id="element-316" data-mp="2rouj4pfbb69v">
                {monthlyPrograms.map((prog, idx) => <div key={idx} className="bg-white p-8 rounded-[2rem] border-2 border-midnight/5 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-317" data-mp="29ywcey7lnw2" data-mpi={idx}>
                    <div className="inline-flex items-center px-3 py-1 bg-gold/10 text-gold rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-318" data-mp="35ttq1amv1pet">
                      {prog.type}
                    </div>
                    <h4 className="text-2xl font-display font-bold text-midnight mb-8 leading-tight" data-id="element-319" data-mp="q14j7e2khgfv">
                      {prog.title}
                    </h4>
                    <div className="space-y-4" data-id="element-320" data-mp="uy4j178tpmyj">
                      <div className="flex items-center gap-3 text-sm font-medium text-charcoal/80" data-id="element-321" data-mp="2fijeo66a9kc4">
                        <div className="w-8 h-8 rounded-full bg-midnight/5 flex items-center justify-center text-midnight group-hover:bg-gold group-hover:text-white transition-colors" data-id="element-322" data-mp="2ain6duqjz6qr">
                          <Calendar className="w-4 h-4" data-id="element-323" data-mp="20tdhsoux467e" />
                        </div>
                        <span data-id="element-324" data-mp="1wrifpi55xosk">{prog.schedule}</span>
                      </div>
                      <div className="flex items-center gap-3 text-sm font-medium text-charcoal/80" data-id="element-325" data-mp="1wpffk5aaqfa4">
                        <div className="w-8 h-8 rounded-full bg-midnight/5 flex items-center justify-center text-midnight group-hover:bg-gold group-hover:text-white transition-colors" data-id="element-326" data-mp="1rus0ex16mx87">
                          <Clock className="w-4 h-4" data-id="element-327" data-mp="1hw2fevdzownq" />
                        </div>
                        <span data-id="element-328" data-mp="3h6tty2hfmd8p">{prog.time}</span>
                      </div>
                    </div>
                  </div>)}
              </motion.div> : <motion.div key="annual" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} className="grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-329" data-mp="1ai1tpptbz1aq">
                {annualPrograms.map((prog, idx) => <div key={idx} className="bg-white p-6 rounded-[2rem] border-2 border-midnight/5 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-330" data-mp="1k9frnt5mvt1r" data-mpi={idx}>
                    <h4 className="text-xl font-display font-bold text-midnight mb-6 leading-tight h-14" data-id="element-331" data-mp="8sfzqyn77g89">
                      {prog.title}
                    </h4>
                    <div className="space-y-3" data-id="element-332" data-mp="5b0nx4tlc5f5">
                      <div className="flex items-center gap-3 text-sm font-medium text-charcoal/80" data-id="element-333" data-mp="5dwlgs1j0s32">
                        <div className="w-7 h-7 rounded-full bg-midnight/5 flex items-center justify-center text-midnight shrink-0 group-hover:bg-gold group-hover:text-white transition-colors" data-id="element-334" data-mp="f37kyibuz2d">
                          <Calendar className="w-3.5 h-3.5" data-id="element-335" data-mp="a8tqlnvoqhao" />
                        </div>
                        <span data-id="element-336" data-mp="3iqzs6or2mj90">{prog.date}</span>
                      </div>
                      <div className="flex items-center gap-3 text-sm font-medium text-charcoal/80" data-id="element-337" data-mp="3dsy57sqixzs9">
                        <div className="w-7 h-7 rounded-full bg-midnight/5 flex items-center justify-center text-midnight shrink-0 group-hover:bg-gold group-hover:text-white transition-colors" data-id="element-338" data-mp="3shb530sqg2s1">
                          <MapPin className="w-3.5 h-3.5" data-id="element-339" data-mp="2zyxg7qpdjr53" />
                        </div>
                        <span className="truncate" data-id="element-340" data-mp="2v02ou0dccu9d">{prog.location}</span>
                      </div>
                    </div>
                  </div>)}
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}